export default "__VITE_ASSET__BwolwHwj__"